import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
import i18n from "@/helpers/i18n";

export interface State {
    companies: any[],
    companiesCount: number,
    loadingCompanies: boolean,
    accounts: any
    accountsCount: number,
    errorEditAccount: boolean,
    errorBlockAccount: boolean,
}


const defaultState: State = {
    companies: [],
    companiesCount: 0,
    loadingCompanies: true,
    accounts: [],
    accountsCount: 0,
    errorEditAccount: false,
    errorBlockAccount: false
};

const getters = {
    companies: (state: State) => state.companies,
    companiesCount: (state: State) => state.companiesCount,
    loadingCompanies: (state: State) => state.loadingCompanies,
    accounts: (state: State) => state.accounts,
    accountsCount: (state: State) => state.accountsCount,
    errorEditAccount: (state: State) => state.errorEditAccount,
    errorBlockAccount: (state: State) => state.errorBlockAccount,
}

const mutations: MutationTree<State> = {
    setCompanies(state: State, payload: any) {
        payload.models.forEach((item: any) => item.loading = false)
        state.companies = payload.models
        state.companiesCount = payload.allCount
    },
    setLoadingCompanies(state: State, payload: boolean) {
        state.loadingCompanies = payload
    },
    // setAccounts(state: State, payload: any) {
    //     state.accounts = payload.models
    //     state.accountsCount = payload.allCount
    // },
    // setAccount(state: State, payload: any) {
    //     payload.loadingBlock = false
    //     let items: any = []
    //     payload.companies.forEach((company: any) => items.push(company.companyTitle))
    //     payload.currentCompanies = items.join(', ')
    //
    //     state.accounts = state.accounts.map((account: any) => {
    //         return account._id == payload._id ? payload : account
    //     })
    // },
    // setErrorEditAccount(state: State, payload: boolean) {
    //     state.errorEditAccount = payload
    // },
    // setErrorBlockAccount(state: State, payload: boolean) {
    //     state.errorBlockAccount = payload
    // },
}

const actions: ActionTree<State, RootState> = {
    async loadCompaniesFromServer({commit, state}, payload: any) {
        commit('setLoadingCompanies', true)
        try {
            const {data} = await Vue.axios.get(
                '/v5/admin/company?' +
                'page=' + payload.page +
                '&per-page=' + payload.itemsPerPage +
                '&sort=' + payload.sort +
                '&search=' + payload.search)
            if (data.error) {
                throw (data.error)
            }
            commit('setLoadingCompanies', false)
            commit('setCompanies', data.data)

        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)

        } finally {
            commit('setLoadingCompanies', false)
        }
    },
    // async changeStatusFromServer({commit, state}, payload: any) {
    //     try {
    //         const {data} = await Vue.axios.patch('/v5/support/appeal/' + payload._id, payload.params)
    //         if (data.error) {
    //             throw (data.error)
    //         }
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'green',
    //             messages: [i18n.t('common.changes_save')]
    //         })
    //     } catch (e) {
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'red',
    //             messages: [e]
    //         })
    //         console.log(e.message)
    //     }
    // },
    // async loadAccountsFromServer({commit, state}, payload: any) {
    //     try {
    //         const {data} = await Vue.axios.get('/v5/users?' +
    //             'page=' + payload.page +
    //             '&per-page=' + payload.itemsPerPage +
    //             '&search=' + payload.search)
    //
    //         if (data.error) {
    //             throw (data.error)
    //         }
    //
    //         data.data.models.forEach((account: any) => {
    //             account.loadingBlock = false
    //             let items: any = []
    //             account.companies.forEach((company: any) => items.push(company.companyTitle))
    //             account.currentCompanies = items.join(', ')
    //         })
    //         data.data.models.forEach((account: any) => account.showTooltip = false)
    //         commit('setAccounts', data.data)
    //     } catch (e) {
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'red',
    //             messages: [e]
    //         })
    //         console.log(e.message)
    //     }
    // },
    // async blockAccountFromServer({commit, state}, payload: any) {
    //     commit('setErrorBlockAccount', false)
    //     try {
    //         const {data} = await Vue.axios.post(`/v5/user/${payload}/block`)
    //         if (data.error) {
    //             throw (data.error)
    //         }
    //         commit('setAccount', data.data.account)
    //     } catch (e) {
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'red',
    //             messages: [e]
    //         })
    //         console.log(e.message)
    //         commit('setErrorBlockAccount', true)
    //     }
    // },
    // async unblockAccountFromServer({commit, state}, payload: any) {
    //     commit('setErrorBlockAccount', false)
    //     try {
    //         const {data} = await Vue.axios.post(`/v5/user/${payload}/unblock`)
    //         if (data.error) {
    //             throw (data.error)
    //         }
    //         commit('setAccount', data.data.account)
    //     } catch (e) {
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'red',
    //             messages: [e]
    //         })
    //         commit('setErrorBlockAccount', true)
    //         console.log(e.message)
    //     }
    // },
    // async editAccountFromServer({commit, state}, payload: any) {
    //     try {
    //         const {data} = await Vue.axios.patch(`/v5/user/${payload.id}/login/change`, payload.params)
    //         if (data.error) {
    //             throw (data.error)
    //         }
    //         commit('setAccount', data.data.account)
    //         commit('setErrorEditAccount', false)
    //     } catch (e) {
    //         this.commit('alerts/setAlert', {
    //             show: true,
    //             color: 'red',
    //             messages: [e]
    //         })
    //         console.log(e.message)
    //         commit('setErrorEditAccount', true)
    //     }
    // },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
